import * as React from 'react';
import { RouteComponentProps, Route, Switch, Redirect } from "react-router";


import { QuestionView } from "components/views/QuestionView";
import { PreliminaryView } from "components/views/PreliminaryView";
import { FinishView } from "components/views/FinishView";


import QuestionnaireContext from 'contexts/QuestionnaireContext';
import { Button } from 'react-bootstrap';
import { QuestionnaireRoute } from 'components/common/QuestionnaireRoute';
import { MainLayout } from 'components/layouts/MainLayout';
import l10n from 'localization/LocalizationData';
import { ExitModal } from 'components/modals/ExitModal';

interface QuestionnaireProps {
	id: string;
}

export const QuestionnairePage = (props: RouteComponentProps<QuestionnaireProps>) => {
	const context = React.useContext(QuestionnaireContext);
	const [showExitModal, setShowExitModal] = React.useState(false);

	function ExitQuestionnaire() {
		context.clear();
		props.history.push('/');
	}

	return (
		<MainLayout header={
			<>
				{context.headerElement}
				<Button onClick={() => setShowExitModal(true)}>{l10n.button_endQuestionnaire}</Button>
			</>
		}>
			<ExitModal accept={ExitQuestionnaire} decline={() => setShowExitModal(false)} show={showExitModal} />
			<Switch>
				<QuestionnaireRoute path='/questionnaire/:id/question/:index?' component={QuestionView} />
				<QuestionnaireRoute path='/questionnaire/:id/preliminary' component={PreliminaryView} />
				<QuestionnaireRoute path='/questionnaire/:id/summary' component={FinishView} />
				<Route path='/'>
					<Redirect to='/questionnaire/:id/question/0' />
				</Route>
			</Switch>
		</MainLayout>
	)
}